import moment from "moment-timezone";
import type { ResultResource, ShiftResult } from "./types";

export interface ResultShiftDetails {
    date?: string;
    startDate?: string;
    endDate?: string;
    duration?: number;
    job?: ResultResource;
    location?: ResultResource;
}

/**
 * swap-shifts results come back with a `shift`, offer-shifts results don't -
 * for those the shift details live on the request that was created.
 */
export const getResultShiftDetails = (row?: ShiftResult): ResultShiftDetails => {
    const shift = row?.shift;

    if (shift) {
        return {
            date: shift.date,
            startDate: shift.startDate,
            endDate: shift.endDate,
            duration: shift.duration,
            job: shift.job,
            location: shift.location,
        };
    }

    const data = row?.request?.data;
    const schedule = data?.schedule;
    const startDate = data?.startDate ?? schedule?.startDate;
    const endDate = data?.endDate ?? schedule?.endDate;
    const duration = data?.duration ?? (
        startDate && endDate
            ? moment.parseZone(endDate).diff(moment.parseZone(startDate), "seconds")
            : undefined
    );

    return {
        date: schedule?.date ?? (startDate ? moment.parseZone(startDate).format("YYYY-MM-DD") : undefined),
        startDate,
        endDate,
        duration,
        job: data?.job,
        location: data?.location,
    };
};
